'use strict';

import {
  apiUrl
} from '../../app.api.config';

export default class InsuranceOfferService {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }
  getDataPage = function (criteria) {
    return this.$http.post(apiUrl().API_URL + '/admin/insuranceOffers/dataPage?XDEBUG_SESSION_START=PHPSTORM', criteria);
  };
  save = function (data) {
    return this.$http.post(apiUrl().API_URL + '/admin/insuranceOffers/?XDEBUG_SESSION_START=PHPSTORM', data);
  };
  update = function (data) {
    return this.$http.put(apiUrl().API_URL + '/admin/insuranceOffers/?XDEBUG_SESSION_START=PHPSTORM', data);
  };
  get = function (id) {
    return this.$http.get(apiUrl().API_URL + '/admin/insuranceOffers/' + id + '?XDEBUG_SESSION_START=PHPSTORM');
  };
  getName = function (id) {
    return this.$http.get(apiUrl().API_URL + '/admin/insuranceOffers/' + id + '/getName?XDEBUG_SESSION_START=PHPSTORM');
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/model/InsuranceOffer.js